const en = {
  '/404/': '/404/',
  '/acquista-report-iic-2020/': '/buy-report-iic-2020/',
  '/grazie-dell-acquisto-report/': '/thank-you-for-the-report-purchase/',
  // '/programma/': '/agenda/'
}

module.exports = {
  it: path => path,
  en: path => en[path]
}